import React from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    NumberInput,
} from "react-admin";
import CreateView from "../../components/CreateView";
import EditView from "../../components/EditView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";

const PlanTypeFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="name"
          source={"name"}
      />
  </Filter>
);

export const PlanTypeList = (props) => (
  <List {...props} filters={<PlanTypeFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <TextField source="name"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        <TextField source="title"/>
        <TextField source="features"/>
      <BooleanField source="isDeleted"/>
    </Datagrid>
  </List>
);

export const PlanTypeCreate = (props) => (
    <CreateView {...props}>
        <TextInput source="name" validate={required()}/>
        <TextInput source="title" validate={required()}/>
        <Emoji source="description" label="توضیحات" />
        <TextInput source="features"/>
        <BooleanInput source="isDeleted" defaultValue={false}/>
    </CreateView>
);


export const PlanTypeEdit = (props) => {
    return (
        <EditView {...props}>
            <TextInput source="name" validate={required()}/>
            <TextInput source="title" validate={required()}/>
            <Emoji source="description" label="توضیحات" />
            <TextInput source="features"/>
            <BooleanInput source="isDeleted" defaultValue={false}/>
        </EditView>
    );
}

export const PlanTypeShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <TextField source="name"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        <TextField source="title"/>
        <TextField source="description"/>
        <BooleanField source="isDeleted"/>
    </SimpleShowLayout>
  </ShowView>
);
